import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { get } from 'lodash';
import CopyToClipboard from '../copy-to-clipboard';
import { formatMessage } from '../../lib/intl';
import pbgLogoBlue from '../../img/keytravel-logo-blue.png';

const i18n = defineMessages({
  copyLink: {
    id: 'invitePeople.RHS.copyLink',
    defaultMessage: 'copy link',
  },
  copied: {
    id: 'invitePeople.RHS.copied',
    defaultMessage: 'copied!',
  },
})
export class InvitesSidebar extends Component {
  constructor(props) {
    super(props);
    this.onCopyLinkClick = this.onCopyLinkClick.bind(this);
    this.formatMessage = formatMessage(this.props.intl);
  }

  onCopyLinkClick(event) {
    const a = event.target;
    a.innerText = this.formatMessage(i18n.copied);
    setTimeout(() => {
      a.innerText = this.formatMessage(i18n.copyLink);
    }, 3000);
  }

  renderMessageText() {
    if (this.props.message) return this.props.message;
    return <FormattedMessage
      id="invitePeople.RHS.messageText"
      defaultMessage="Click through for all the details, and you can decide whether to contribute."
    />;
  }

  renderBrandLogo() {
    const imageSource = get(this.props, 'merchant.logoUrl', pbgLogoBlue);
    const imageAlt = get(this.props, 'merchant.displayName', 'Key Travel');
    return <img src={imageSource} alt={imageAlt} className="brand-logo mt-2" />;
  }

  render() {
    return (
      <div className="invites-form-sidebar">
        <div className="invitees-preview pt-5">

          <div className="email-preview-wrapper">
            <div className="email-header" />
            <div className="email-body p-2">
              {this.renderBrandLogo()}

              <p className="mt-2 email-title">
                {this.props.subject}
              </p>

              <p>
                {this.renderMessageText()}
              </p>
            </div>
            <div className="email-footer" />
          </div>
        </div>
        <div className="right-sidebar-footer container mt-2">
          <p className="text-center">
            <FormattedMessage
              id="invitePeople.RHS.preview"
              defaultMessage="Preview of the email your invitees will receive"
            />
          </p>
          <hr />
          <p>
            <strong className="greyish-brown">
              <FormattedMessage
                id="invitePeople.RHS.troubleshoot.title"
                defaultMessage="Invitees not receiving emails?"
              />
            </strong>
          </p>
          <p>
            <FormattedMessage
              id="invitePeople.RHS.troubleshoot.checkSpam"
              defaultMessage="- Have them check their spam or promotional email folder"
            />
          </p>
          <p>
            <FormattedMessage
              id="invitePeople.RHS.troubleshoot.searchForSender"
              defaultMessage="- Have them search their inbox for {sender}"
              values={{ sender: <em>info@paybygroup.com</em> }}
            />
          </p>
          <p>
            <FormattedMessage
              id="invitePeople.RHS.troubleshoot.sendLink"
              defaultMessage="- Send them this link directly: {link}"
              values={{
                link: <CopyToClipboard text={window.location.href} >
                  <a className="copy-to-clipboard clear-blue" href="#copy-link" onClick={this.onCopyLinkClick}>
                    {this.formatMessage(i18n.copyLink).toLowerCase()}
                  </a>
                </CopyToClipboard>
              }}
            />
          </p>
        </div>
      </div>
    );
  }
}

export default injectIntl(InvitesSidebar);



// WEBPACK FOOTER //
// ./src/desktop/components/invite-people/right-sidebar.js